import { useEffect, useState } from "react";
import { FUN_FACTS } from "@/data/content";
import { Sparkles } from "lucide-react";
import BookingButton from "./BookingButton";

export default function FunFacts() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setI((x) => (x + 1) % FUN_FACTS.length), 5500);
    return () => clearInterval(id);
  }, []);

  return (
    <section
      className="py-20 lg:py-24 border-y"
      style={{ background: "var(--sano-olive)", borderColor: "var(--sano-olive-dark)", color: "var(--sano-bg)" }}
      data-testid="funfacts-section"
    >
      <div className="max-w-5xl mx-auto px-6 lg:px-12 text-center">
        <div className="inline-flex items-center gap-2 eyebrow mb-6" style={{ color: "var(--sano-bg-2)" }}>
          <Sparkles size={14} strokeWidth={1.5} /> Did you know
        </div>
        <p
          key={i}
          className="font-serif-display text-2xl sm:text-3xl lg:text-4xl leading-snug italic soft-up"
          data-testid="funfact-text"
        >
          “{FUN_FACTS[i]}”
        </p>
        <div className="mt-8 flex items-center justify-center gap-1.5">
          {FUN_FACTS.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setI(idx)}
              className="h-1 rounded-full transition-all"
              style={{
                width: idx === i ? 22 : 6,
                background: idx === i ? "var(--sano-bg)" : "rgba(249,246,240,0.4)",
              }}
              aria-label={`Fact ${idx + 1}`}
              data-testid={`funfact-dot-${idx}`}
            />
          ))}
        </div>
        <div className="mt-10 flex justify-center">
          <BookingButton testid="funfacts-book-btn" variant="light" label="Experience it yourself" />
        </div>
      </div>
    </section>
  );
}
